import {FC, useState} from 'react'
import ShippingPackageDialog from './ShippingPackageDialog'

type Props = {}
const AddPackageButton: FC<Props> = () => {
  const [showDialog, setShowDialog] = useState(false)

  const handleClick = () => {
    setShowDialog(true)
  }

  const handleClose = () => {
    setShowDialog(false)
  }

  return (
    <>
      <button
        id='btnAddPackage'
        type='button'
        onClick={handleClick}
        className='btn btn-sm btn-primary'
      >
        Add package
      </button>
      {showDialog && <ShippingPackageDialog showDialog={showDialog} onClose={handleClose} />}
    </>
  )
}
export default AddPackageButton
